import React, { useEffect, useRef, useState } from 'react';
import { Box } from '@mui/material';

/* Respect the user's reduced-motion preference (a11y). */
export function usePrefersReducedMotion() {
  const [reduced, setReduced] = useState(false);
  useEffect(() => {
    const m = window.matchMedia('(prefers-reduced-motion: reduce)');
    setReduced(m.matches);
    const handler = () => setReduced(m.matches);
    m.addEventListener?.('change', handler);
    return () => m.removeEventListener?.('change', handler);
  }, []);
  return reduced;
}

/* Scroll-reveal wrapper — no-ops to an instant render under reduced-motion. */
export function Reveal({ children, delay = 0, y = 24, sx }) {
  const ref = useRef(null);
  const reduced = usePrefersReducedMotion();
  const [shown, setShown] = useState(false);
  useEffect(() => {
    if (reduced) {
      setShown(true);
      return undefined;
    }
    const el = ref.current;
    if (!el) return undefined;
    const obs = new IntersectionObserver(
      ([e]) => {
        if (e.isIntersecting) {
          setShown(true);
          obs.disconnect();
        }
      },
      { threshold: 0.12 }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, [reduced]);
  return (
    <Box
      ref={ref}
      sx={{
        opacity: shown ? 1 : 0,
        transform: shown ? 'translateY(0)' : `translateY(${y}px)`,
        transition: reduced
          ? 'none'
          : `opacity .7s ease ${delay}ms, transform .7s cubic-bezier(.16,.84,.44,1) ${delay}ms`,
        ...sx,
      }}
    >
      {children}
    </Box>
  );
}
